import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';

// On a phone the graph builders are a canvas of small drag targets (DWLF-307): they still open, so a
// saved strategy or event can be read and run, but say plainly that editing is a larger-screen job.
export default function DesktopBestNotice({ what = 'This builder' }) {
  const phone = useMediaQuery((t) => t.breakpoints.down('md'));
  if (!phone) return null;
  return (
    <Box role="note" sx={{ border: '1px dashed var(--dwlf-warn-40)', backgroundColor: 'var(--dwlf-warn-08)', px: 1.5, py: 1, mb: 1.5 }}>
      <Typography sx={{ fontFamily: '"IBM Plex Mono", monospace', fontSize: '0.75rem', color: 'var(--dwlf-text)' }}>
        {what} is made for a larger screen. You can read and run it here; editing works best on a laptop or tablet.
      </Typography>
    </Box>
  );
}
